import aria from './aria.json' with { type: 'json' };
import badges from './badges.json' with { type: 'json' };
import buttons from './buttons.json' with { type: 'json' };
import errors from './errors.json' with { type: 'json' };
import labels from './labels.json' with { type: 'json' };
import links from './links.json' with { type: 'json' };
import pages from './pages';
import tables from './tables.json' with { type: 'json' };
import titles from './titles.json' with { type: 'json' };

export default {
  aria,
  badges,
  buttons,
  errors,
  labels,
  links,
  pages,
  tables,
  titles,
};
